import type { TFunction } from 'i18next';
import React from 'react';

import { Grid } from '../../../common/components/Grid/Grid';
import {
  GridColumn,
  GridCountFunction,
  GridGetterFunction,
} from '../../../common/components/Grid/GridDataTypes';
import { GetSpecialInvoicingDto } from '../../../common/pokCore/autogenerated/pokApiClient';
import momencik from '../../../common/momencik';
import { useTranslation } from '../../../common/hooks/useTranslation';
import { buildProjectLabel } from '../../../utils/buildProjectLabel';
import { SpecialInvoicingStatusObj } from '../../../common/pokCore/validation/enums';

interface SpecialInvoicingSearchProps {
  getData?: GridGetterFunction;
  getCount?: GridCountFunction;
  onRowClick?: (
    key: string,
    newWindow?: boolean,
  ) => Promise<void> | void | undefined;
  refresh?: boolean;
}

export const specialInvoicingForGrid = (
  t: TFunction<'applicationLng', 'applicationLng'>,
  specialInvoicing: GetSpecialInvoicingDto,
) => {
  return {
    key: specialInvoicing.id,
    values: {
      'specialInvoicing.systemNumber': specialInvoicing.systemNumber,
      'specialInvoicing.creationTs': momencik(specialInvoicing.creationTs),
      'specialInvoicing.status': t(
        SpecialInvoicingStatusObj[specialInvoicing.status],
      ),
      'project.name': specialInvoicing.specialInvoicingProjects
        ?.map(({ project }) => buildProjectLabel(project))
        .join(', '),
      'creator.name': specialInvoicing.creator?.name,
    },
    isInactive: !specialInvoicing.active,
  };
};

export const SpecialInvoicingSearch: React.FC<
  SpecialInvoicingSearchProps
> = props => {
  const { t, tk } = useTranslation('applicationLng');
  const columns: GridColumn[] = [
    {
      header: t(tk.common.sysNumber),
      property: 'specialInvoicing.systemNumber',
    },
    {
      header: t(tk.common.creationDate),
      property: 'specialInvoicing.creationTs',
    },
    { header: t(tk.common.creator), property: 'creator.name' },
    { header: t(tk.prLang.projects), property: 'project.name' },
    { header: t(tk.common.status), property: 'specialInvoicing.status' },
  ];

  return (
    <Grid
      getData={props.getData}
      getDataCount={props.getCount}
      columns={columns}
      showFilter={true}
      refresh={props.refresh}
      initialOrderColumn="specialInvoicing.systemNumber"
      initialOrderDirection={'DESC'}
      availablePageSizes={[10, 20, 50]}
      emptyGridMessage={t(tk.app.noSpecialInvoiceApplications)}
      onRowClick={props.onRowClick}
      withHistory={true}
    />
  );
};
